import(/* webpackMode: "eager" */ "/app/src/app/[lng]/(use-auth)/proveedores/page.tsx");
